module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./~/react-async-script/~/core-js/library/modules/$.add-to-unscopables.js
// module id = 1273
// module chunks = 0